import moment from 'moment';

export const getFormatedDate = (date = moment()) => moment(date).format('HH:mm:ss DD/MM/YYY');

export const getDate = (date = moment()) => moment(date).format('DD/MM/YYY');
